import React from 'react';

//components
import BasicCheckBox from '../../../global/buttons/BasicCheckbox';

//interfaces
import { IConditionCheckboxPanel } from '../../interfaces/IConditionCheckboxPanel';



const ConditionCheckboxPanel = ({
    formElementId,
    isRequiredElement,
    setIsRequiredElement, 
    conditionalRuleEnabled, 
    setConditionalRuleEnabled, 
    }: IConditionCheckboxPanel
) => {    
    return (
        <div className='condition-checkbox-panel'>
            <div className='checkboxes'>
                <BasicCheckBox 
                    id={`required-checkbox-for-input-${formElementId}`} 
                    isChecked={isRequiredElement} 
                    onChange={setIsRequiredElement} 
                    label={'Required'} 
                />

                <BasicCheckBox 
                    id={`condition-enable-checkbox-for-input-${formElementId}`} 
                    isChecked={conditionalRuleEnabled} 
                    onChange={setConditionalRuleEnabled} 
                    label={'Add Conditional Logic'} 
                />
            </div>
        </div>
    );
};

export default ConditionCheckboxPanel 